"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayEnrichmentAssignmentEntity = void 0;
const swagger_1 = require("@nestjs/swagger");
const display_enrichment_snapshot_entity_1 = require("./display-enrichment-snapshot.entity");
class DisplayEnrichmentAssignmentEntity {
    /**
     * @deprecated
     */
    _id;
    id;
    displayId;
    type;
    snapshotId;
    provider;
    assignedAt;
    expiresAt;
    createdAt;
    updatedAt;
}
exports.DisplayEnrichmentAssignmentEntity = DisplayEnrichmentAssignmentEntity;
__decorate([
    (0, swagger_1.ApiPropertyOptional)({ deprecated: true }),
    __metadata("design:type", String)
], DisplayEnrichmentAssignmentEntity.prototype, "_id", void 0);
__decorate([
    (0, swagger_1.ApiProperty)(),
    __metadata("design:type", String)
], DisplayEnrichmentAssignmentEntity.prototype, "id", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ example: "display_01HZY7Q3P4M2K8C9D1E2F3G4H5" }),
    __metadata("design:type", String)
], DisplayEnrichmentAssignmentEntity.prototype, "displayId", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ enum: display_enrichment_snapshot_entity_1.DISPLAY_ENRICHMENT_SNAPSHOT_TYPES }),
    __metadata("design:type", String)
], DisplayEnrichmentAssignmentEntity.prototype, "type", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ example: "6627f95cc3d9123456789abc" }),
    __metadata("design:type", String)
], DisplayEnrichmentAssignmentEntity.prototype, "snapshotId", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ example: "datos-espana" }),
    __metadata("design:type", String)
], DisplayEnrichmentAssignmentEntity.prototype, "provider", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ example: "2026-04-30T10:00:00.000Z" }),
    __metadata("design:type", String)
], DisplayEnrichmentAssignmentEntity.prototype, "assignedAt", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({ example: "2027-04-30T10:00:00.000Z" }),
    __metadata("design:type", Object)
], DisplayEnrichmentAssignmentEntity.prototype, "expiresAt", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ example: "2026-04-30T10:00:00.000Z" }),
    __metadata("design:type", String)
], DisplayEnrichmentAssignmentEntity.prototype, "createdAt", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ example: "2026-04-30T10:00:00.000Z" }),
    __metadata("design:type", String)
], DisplayEnrichmentAssignmentEntity.prototype, "updatedAt", void 0);
